export default {
  Routes: {
    'read:any': ['brands-list', 'partners-list', 'brands-card', 'partners-card'],
  }
}
